import { motion } from 'framer-motion';
import { audio } from '../core/audio';

export function ClayButton({ children, color = '#FFD166', onClick, className = '', testId, disabled, small }) {
  return (
    <motion.button
      data-testid={testId}
      disabled={disabled}
      whileTap={{ scale: 0.94, y: 4 }}
      onClick={(e) => { audio.playSfx('tap'); onClick?.(e); }}
      className={`select-none touch-manipulation font-heading font-bold text-navy rounded-[2rem] ${small ? 'min-h-[64px] px-6 text-xl' : 'min-h-[76px] px-9 text-2xl'} ${className}`}
      style={{
        background: color,
        boxShadow: 'inset 0 -8px 0 rgba(0,0,0,0.14), inset 0 4px 0 rgba(255,255,255,0.35), 0 10px 22px rgba(29,53,87,0.18)',
        opacity: disabled ? 0.5 : 1,
      }}>
      {children}
    </motion.button>
  );
}
